import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/dashboard/')({
	component: () => <Navigate to='/p/dashboard/main' replace />,
})
